import React, { useEffect, useState } from "react";
import { useAuthState } from "../../../Helper/Context/context";
import { useDispatch, useSelector } from "react-redux";
import { CompletedMileStoneViewPopupTableDataAPI } from "../../../Redux/ProjectCreationAllocationSlice/PhysicalWorkProgressSlice";
import LoaderFile from "../../../Helper/Loader/LoaderFile";
import BeforeAfterPhotoShowModal from "./BeforeAfterPhotoShowModal";
import ViewAttachment from "./ViewAttachment";

export default function PhysicalWorkProgressViewPopUp({ flag, open, handleAddCloseClick, dataList }) {

	const userDetails = useAuthState();
	const { UserID, token } = userDetails;
	const dispatch = useDispatch();

	const [To, setTo] = useState(10000);
	const [BeforeAfterPhotoShow, setBeforeAfterPhotoShow] = useState(false);
	const [Flag, setFlag] = useState('');

	const handleBeforeAfterModalShow = (data, flag) => {
		setBeforeAfterPhotoShow(true);
		setFlag(flag);
	};

	const handleBeforeAfterModalclose = () => {
		setBeforeAfterPhotoShow(false);
	};

	const [ViewAttachmentPopUp, setViewAttachmentPopUp] = useState(false)
	const [loader, setloader] = useState(false)

	const handleViewAttachModal = (i) => {
		// console.log("fgdfg",i)
		sessionStorage.setItem('Url', i)
		setViewAttachmentPopUp(!ViewAttachmentPopUp)
	}

	useEffect(() => {
		const data = {
			M_WardID: 0,
			T_ProjectSanctionDetailsID: dataList.t_ProjectSanctionDetailsID,
			M_ProjectID: 0,
			Flag: 'CompleteWork',
			M_UsersID: UserID,
			token: token,
			Top: To,
		};
		dispatch(CompletedMileStoneViewPopupTableDataAPI({ data }));
	}, [dispatch, dataList.t_ProjectSanctionDetailsID, To, UserID, token]);

	const { tableData, isLoading } = useSelector(state => state.CompletedMileStoneViewPopupTableData);

	return (
		<div>
			{isLoading && <LoaderFile />}

			<div className="modal fade show" style={{ display: "flex", alignItems: 'center', backgroundColor: "#00000090" }}  >
				<div className="modal-dialog modal-xl" role="document">
					<div className="modal-content p-4">
						<div className="modal-header pt-0">
							<h5 className="card-title text-dark fw-bold" id="exampleModalLongTitle">Milestone View Gallery</h5>
							<button onClick={() => handleAddCloseClick()} type="button" className="close border_cancel_btn" style={{ marginLeft: "auto" }}>
								<span aria-hidden="true" className=" py-0" style={{ color: "red" }}>&times;</span>
							</button>
							{/* <button onClick={() => handleAddCloseClick()} type="button" className="close border_cancel_btn" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true" className=" py-0" style={{ color: "red" }}>&times;</span>
                            </button>     */}
						</div>
						<div className="modal-body">
							<div className="tbl-sticky">
								<div className="table-responsive_fix">
									<table
										cellPadding="0"
										cellSpacing="0"
										border="0"
										className="table table-bordered"
									>
										<thead className="header_position">
											<tr>
											<th width="2%">Sr.No.</th>
												<th width = '18%'>Milestone Name</th>
												<th width = '40%'>Before Photo</th>
												<th width = '40%'>After Photo</th>
											</tr>
										</thead>
										<tbody>
											{tableData && tableData.length > 0 ? (
												tableData.map((item, i) => (
													<tr key={i}>
														<td className="text_center">{item?.rowNum}</td>
														<td>
															{item?.milestone_Name ? item?.milestone_Name : "-"}
														</td>
														<td className="text_center">
															<div className="row">
																<div className="col-12 col-lg-6">
																	<button className="btn p-0 mrb50"
																		id="dynamic"
																		onClick={(e) => item?.beforePhoto1 != null ? handleViewAttachModal(item?.beforePhoto1) : e.preventDefault()}
																		onError={(e) => {
																			e.target.src = "./assets/img/404image.jpeg"
																		}}
																	>
																		<div className="container px-0" style={{ zIndex: '0' }}>
																			<img src={item?.beforePhoto1 != null ? item?.beforePhoto1 : './assets/img/no_img-01.jpg'} alt="" className="img-thumbnail image image-size" />
																			<div className="overlay">
																				<div className="text">View Image</div>
																			</div>
																		</div>
																	</button>
																</div>
																<div className="col-12 col-lg-6">

																	<button className="btn p-0 mrb50"
																		id="dynamic"
																		onClick={(e) => item?.beforePhoto2 != null ? handleViewAttachModal(item?.beforePhoto2) : e.preventDefault()}
																		onError={(e) => {
																			e.target.src = "./assets/img/404image.jpeg"
																		}}
																	>
																		<div className="container px-0" style={{ zIndex: '0' }}>
																			<img src={item?.beforePhoto2 != null ? item?.beforePhoto2 : './assets/img/no_img-01.jpg'} alt="" className="img-thumbnail image  image-size" />
																			<div className="overlay">
																				<div className="text">View Image</div>
																			</div>
																		</div>
																	</button>

																</div>
																<div className="col-12 col-lg-6">

																	<button className="btn p-0 mrb50"
																		id="dynamic"
																		onClick={(e) => item?.beforePhoto3 != null ? handleViewAttachModal(item?.beforePhoto3) : e.preventDefault()}
																		onError={(e) => {
																			e.target.src = "./assets/img/404image.jpeg"
																		}}
																	>
																		<div className="container px-0" style={{ zIndex: '0' }}>
																			<img src={item?.beforePhoto3 != null ? item?.beforePhoto3 : './assets/img/no_img-01.jpg'} alt="" className="img-thumbnail image  image-size" />
																			<div className="overlay">
																				<div className="text">View Image</div>
																			</div>
																		</div>
																	</button>

																</div>
																<div className="col-12 col-lg-6">
																	<button className="btn p-0 mrb50"
																		id="dynamic"
																		onClick={(e) => item?.beforePhoto4 != null ? handleViewAttachModal(item?.beforePhoto4) : e.preventDefault()}
																		onError={(e) => {
																			e.target.src = "./assets/img/404image.jpeg"
																		}}
																	>
																		<div className="container px-0" style={{ zIndex: '0' }}>
																			<img src={item?.beforePhoto4 != null ? item?.beforePhoto1 : './assets/img/no_img-01.jpg'} alt="" className="img-thumbnail image  image-size"  />
																			<div className="overlay">
																				<div className="text">View Image</div>
																			</div>
																		</div>
																	</button>

																</div>
															</div>
															{/* <button
																type="button"
																className="btn btn-primary p-2"
																onClick={() =>
																	handleBeforeAfterModalShow(item, "Before Photo")
																}
															>
																View
															</button> */}
														</td>
														<td className="text_center">
															<div className="row">
																<div className="col-12 col-lg-6">

																	<button className="btn p-0 mrb50" id="dynamic"
																		onClick={(e) => item?.afterPhoto1 != null ? handleViewAttachModal(item?.afterPhoto1) : e.preventDefault()}
																		onError={(e) => {
																			e.target.src = "./assets/img/404image.jpeg"
																		}}
																	>
																		<div className="container  px-0" style={{ zIndex: '0' }}>
																			<img src={item?.afterPhoto1 != null ? item?.afterPhoto1 : './assets/img/no_img-01.jpg'} alt="" className="img-thumbnail image  image-size"  />
																			<div className="overlay">
																				<div className="text">View Image</div>
																			</div>
																		</div>
																	</button>

																</div>
																<div className="col-12 col-lg-6">

																	<button className="btn p-0 mrb50"
																		id="dynamic"
																		onClick={(e) => item?.afterPhoto2 != null ? handleViewAttachModal(item?.afterPhoto2) : e.preventDefault()}
																		onError={(e) => {
																			e.target.src = "./assets/img/404image.jpeg"
																		}}
																	>
																		<div className="container px-0" style={{ zIndex: '0' }}>
																			<img src={item?.afterPhoto2 != null ? item?.afterPhoto2 : './assets/img/no_img-01.jpg'} alt="" className="img-thumbnail image  image-size" />

																			<div className="overlay">
																				<div className="text">View Image</div>
																			</div>
																		</div>
																	</button>

																</div>
																<div className="col-12 col-lg-6">

																	<button className="btn p-0 mrb50"
																		id="dynamic"
																		onClick={(e) => item?.afterPhoto3 != null ? handleViewAttachModal(item?.afterPhoto3) : e.preventDefault()}
																		onError={(e) => {
																			e.target.src = "./assets/img/404image.jpeg"
																		}}
																	>
																		<div className="container px-0" style={{ zIndex: '0' }}>
																			<img src={item?.afterPhoto3 != null ? item?.afterPhoto3 : './assets/img/no_img-01.jpg'} alt="" className="img-thumbnail image image-size" />
																			<div className="overlay">
																				<div className="text">View Image</div>
																			</div>
																		</div>
																	</button>

																</div>
																<div className="col-12 col-lg-6">

																	<button className="btn p-0 mrb50"
																		id="dynamic"
																		onClick={(e) => item?.afterPhotoLat4 != null ? handleViewAttachModal(item?.afterPhotoLat4) : e.preventDefault()}
																		onError={(e) => {
																			e.target.src = "./assets/img/404image.jpeg"
																		}}
																	>
																		<div className="container px-0" style={{ zIndex: '0' }}>
																			<img src={item?.afterPhotoLat4 != null ? item?.afterPhotoLat4 : './assets/img/no_img-01.jpg'} alt="" className="img-thumbnail image image-size" />
																			<div className="overlay">
																				<div className="text">View Image</div>
																			</div>
																		</div>
																	</button>

																</div>
															</div>
															{/* <button
																type="button"
																className="btn btn-primary p-2"
																onClick={() =>
																	handleBeforeAfterModalShow(item, "After Photo")
																}
															>
																View
															</button> */}
														</td>
													</tr>
												))
											) : (
												<tr>
													<td colSpan="4" className="text-center">
														No data
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{/* Before After Photo Modal */}
			{BeforeAfterPhotoShow && (
				<BeforeAfterPhotoShowModal
					handleBeforeAfterModalShow={handleBeforeAfterModalShow}
					handleBeforeAfterModalclose={handleBeforeAfterModalclose}
					BeforeAfterPhotoShow={BeforeAfterPhotoShow}
					tableData={tableData}
					isLoading={isLoading}
					Flag={Flag}
				/>
			)}

			{
				ViewAttachmentPopUp &&
				<ViewAttachment
					handleViewAttachModal={handleViewAttachModal}
					ViewAttachmentPopUp={ViewAttachmentPopUp}
				/>
			}
		</div>
	);
}
